module.exports = "/static/media/send_icon.2fd51402.svg";